export default __webpack_public_path__ + "static/char-s-11-kr-6020b54ab2c0ca8aef1d180a222d33e4.png";